import { setApiBaseUrl } from './api'
import { regionConfig } from './regionConfig'

/**
 * Point a public-link page at the cluster encoded in its URL.
 *
 * Older single-region builds have only VITE_ORBIO_API_BASE_URL. In that case the
 * axios client is already configured and there is no region map to consult.
 */
export function configureCandidateLinkApi(region: string | undefined): boolean {
  const regionUrl = region ? regionConfig.regions[region] : undefined
  if (regionUrl) {
    setApiBaseUrl(regionUrl)
    return true
  }
  return !regionConfig.isMultiRegion
}

const languageQuery = (language: string | undefined): string =>
  language ? `?lang=${encodeURIComponent(language)}` : ''

export function candidatePrivacyNoticePath(
  region: string | undefined,
  code: string,
  language?: string,
): string {
  return `/candidate/${encodeURIComponent(region || '')}/${encodeURIComponent(code)}/privacy${languageQuery(language)}`
}

export function candidateSessionPrivacyNoticePath(
  region: string | undefined,
  language?: string,
): string {
  return `/candidate/${encodeURIComponent(region || '')}/privacy${languageQuery(language)}`
}
